<template>
  <div
    class="grid-view"
  >
    <div class="main-content">
      <search-item
        ref="searchItem"
        config-module="2500"
        :reset="true"
        :custom-sim-query-placeholder="$t('CargoMsg.Cargo_QueryTip')"
        @click-more="value=>isAdvancedQuery=value"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
        @advSearchItemResetCallBack="toAdvancedQuery"
      >
        <div slot="operations">
          <el-form label-position="left" style="display: flex">
            <div>
              <el-button no="look" :disabled="!selectData" type="success" @click="toLook()">{{ $t('common.btn.look') }}</el-button>
              <el-button
                v-if="$checkPermission(['button_cabinManagement_edit'])"
                no="edit"
                :disabled="!selectData"
                type="primary"
                @click="toEdit()"
              >{{ $t('common.btn.edit') }}
              </el-button>

              <el-dropdown
                v-if="$checkPermission(['button_cabinManagement_importOfCabinSpace']) || $checkPermission(['button_cabinManagement_add'])"
                no="exportOrderHandle"
                split-button
                type="primary"
                style="margin:0 5px"
                @click="exportOrderHandle()"
                @command="p=>{exportOrderCommand=p;exportOrderHandle()}"
              >
                <span v-if="exportOrderCommand === $t('CargoMsg.Cargo_DownImportTemplate') && $checkPermission(['button_cabinManagement_importOfCabinSpace'])">{{ $t('CargoMsg.Cargo_DownImportTemplate') }}</span>
                <span v-else-if="exportOrderCommand !== $t('CargoMsg.Cargo_Import2')">{{ exportOrderCommand }}</span>
                <el-upload
                  v-if="exportOrderCommand === $t('CargoMsg.Cargo_Import2')"
                  :action="URL.booking.cabinManagement.importTemplate"
                  :headers="headers"
                  :show-file-list="false"
                  accept=".xls, .xlsx"
                  :before-upload="beforeOrderUpload"
                  :on-success="uploadOrderSuccess"
                  :on-error="handleError"
                  :data="{branchId:$store.getters.currentOfficeId, lob:'SE'}"
                  style="display: inline-block; margin-left: 5px"
                >
                  <span style="color: white">{{ $t('CargoMsg.Cargo_Import2') }}</span>
                </el-upload>

                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="$checkPermission(['button_cabinManagement_add'])" :command="$t('CargoMsg.Cargo_NewTo')">
                    {{ $t('CargoMsg.Cargo_NewTo') }}
                  </el-dropdown-item>
                  <el-dropdown-item v-if="$checkPermission(['button_cabinManagement_importOfCabinSpace'])" :command="$t('CargoMsg.Cargo_Import2')">
                    <el-upload
                      ref="uploadOrder"
                      :action="URL.booking.cabinManagement.importTemplate"
                      :headers="headers"
                      :show-file-list="false"
                      accept=".xls, .xlsx"
                      :before-upload="beforeOrderUpload"
                      :on-success="uploadOrderSuccess"
                      :on-error="handleError"
                      :data="{branchId:$store.getters.currentOfficeId}"
                      style="display: inline-block"
                    >
                      <el-button slot="trigger" type="text" style="padding-left: 0px;color: #6F6F6F;text-align: left;width: 80px;">{{ $t('CargoMsg.Cargo_Import2') }}</el-button>
                    </el-upload>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="$checkPermission(['button_cabinManagement_importOfCabinSpace'])" :command="$t('CargoMsg.Cargo_DownImportTemplate')">
                    {{ $t('CargoMsg.Cargo_DownImportTemplate') }}
                  </el-dropdown-item>

                </el-dropdown-menu>
              </el-dropdown>

              <el-button
                no="Clone"
                type="primary"
                @click="toClone()"
              >{{ $t('SeaExport.Clone') }}
              </el-button>

              <el-dropdown
                v-if="$checkPermission(['button_cabinManagement_cabinSpaceBackFill']) || $checkPermission(['button_cabinManagement_revokeAllocation']) || $checkPermission(['button_cabinManagement_cabinReturn'])"
                no="batchHandle"
                style="padding-left: 5px;font-size: 12px"
                @command="batchHandle"
              >
                <el-button type="primary">
                  {{ $t('CargoMsg.Cargo_BatchProcessing') }}
                  <i class="el-icon-arrow-down el-icon--right" />
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="$checkPermission(['button_cabinManagement_cabinSpaceBackFill'])" :command="1">{{ $t('CargoMsg.Cargo_CabinSpaceBackFill') }}</el-dropdown-item>
                  <el-dropdown-item v-if="$checkPermission(['button_cabinManagement_revokeAllocation'])" :command="2">{{ $t('CargoMsg.Cargo_RevokeAllocation') }}</el-dropdown-item>
                  <el-dropdown-item v-if="$checkPermission(['button_cabinManagement_cabinReturn'])" :command="3">{{ $t('CargoMsg.Cargo_CancelCabinReservation') }}</el-dropdown-item>
                  <el-dropdown-item v-if="$checkPermission(['button_cabinManagement_batchVessel'])" :command="4">{{
                    $t('SeaExport.BatchVessel')
                  }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <el-dropdown
                v-if="$checkPermission(['button_cabinManagement_AllocateSEBooking']) || $checkPermission(['button_cabinManagement_AllocateVerify'])
                  || $checkPermission(['button_cabinManagement_AllocateCreateSEBooking']) || $checkPermission(['button_cabinManagement_AllocateCreateVerify'])"
                no="allocationHandle"
                style="padding-left: 5px;font-size: 12px"
                @command="allocationHandle"
              >
                <el-button type="primary">
                  {{ $t('CargoMsg.Cargo_AllocateCabinSpace') }}
                  <i class="el-icon-arrow-down el-icon--right" />
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="$checkPermission(['button_cabinManagement_AllocateSEBooking']) || $checkPermission(['button_cabinManagement_AllocateVerify'])" :command="1">{{ $t('CargoMsg.Cargo_Allocate1') }}</el-dropdown-item>
                  <el-dropdown-item v-if="$checkPermission(['button_cabinManagement_AllocateCreateSEBooking']) || $checkPermission(['button_cabinManagement_AllocateCreateVerify'])" :command="2">{{ $t('CargoMsg.Cargo_Allocate2') }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-button
                v-if="$checkPermission(['button_cabinManagement_returnRecovery'])"
                no="returnRecovery"
                type="primary"
                style="margin:0 5px"
                @click="handleShutOut"
              >{{ $t('CargoMsg.Cargo_ShutOut2') }}
              </el-button>
              <el-button
                v-if="$checkPermission(['button_cabinManagement_deleteCabin'])"
                no="deleteCabin"
                type="danger"
                style="margin:0 5px"
                @click="deleteCabinHandler"
              >{{ $t('SeaExport.Delete') }}
              </el-button>
            </div>
            <div style="padding-left: 10px">
              <el-form-item :label="''">
                <el-radio-group v-model="listType" no="1" @change="toQuery">
                  <el-radio :label="0">{{ $t('CargoMsg.Cargo_DisplayByBillOfLading') }}</el-radio>
                  <el-radio :label="1">{{ $t('CargoMsg.Cargo_DisplayByDateAndVoyageNo') }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <div v-if="$checkPermission(['button_cabinManagement_viewSeaexportJob'])" style="padding-left: 30px" class="custom-checkbox">
              <el-form-item>
                <el-checkbox v-model="showSeaExportJob" no="showSeaExportJob">{{ $t('CargoMsg.Cargo_ShowSeaExportJob') }}</el-checkbox>
              </el-form-item>
            </div>
            <div :style="{ paddingLeft: '30px', minWidth: $selectByLang('400px', '400px', '400px', '600px', '600px', '600px') }" class="custom-checkbox">
              <el-form-item label-width="0">
                <el-row>
                  <el-col :span="7"><span style="font-size: 14px;">{{ $t('SeaExport.DateOfDeparture2') }}</span></el-col>
                  <el-col :span="7">
                    <el-form-item label-width="0">
                      <el-date-picker
                        v-model="businessDate[0]"
                        no="5"
                        type="date"
                        style="width:100%;"
                        :picker-options="pickerOptions"
                        clearable
                        value-format="yyyy-MM-dd"
                      /></el-form-item>
                  </el-col>
                  <el-col :span="1" style="text-align: center;"><span style="font-size: 12px;">{{ $t('CargoMsg.Cargo_To') }}</span></el-col>
                  <el-col :span="7">
                    <el-form-item label-width="0">
                      <el-date-picker
                        v-model="businessDate[1]"
                        no="6"
                        type="date"
                        style="width:100%;"
                        clearable
                        :picker-options="pickerOptions"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </search-item>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          v-show="listType === 0"
          config-module="25000522"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          @gridReady="params=>gridApi=params.api"
        />
        <cargo-ag-grid
          v-show="listType === 1"
          config-module="25000523"
          :grid-params.sync="treeGridParams"
          :grid-options="treeGridOptions"
          :column-defs="treeColumnDefs"
          :row-data="rowData"
          @gridReady="params=>treeGridApi=params.api"
        />
      </div>
      <div class="pagination-wrapper">
        <div :class="'fixedBottom'" style="display: flex;justify-content: flex-end;flex-wrap: wrap">
          <span v-show="selectedRows.length > 0">
            {{ $t('Clearing.Selected') + selectedRows.length + ':' + selectRowDataLabel }}
          </span>
        </div>
        <cargo-pagination
          config-module="25000521"
          :total="filter.total"
          :page-count="pageCount"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="toQuery"
        />
      </div>
    </div>

    <!--    退关业务新增舱位 -->
    <customs-return-recovery
      v-if="customsReturnRecoveryWindow.visible"
      ref="CustomsReturnRecovery"
      :source-type="customsReturnRecoveryWindow.sourceType"
      :visible.sync="customsReturnRecoveryWindow.visible"
      :title="customsReturnRecoveryWindow.title"
      :cabin-data="customsReturnRecoveryWindow.cabinData"
      @confirmSync="confirmSyncHandler"
      @allocation="toQuery"
    />

    <!--  分配-创建业务  -->
    <allocation-create
      v-if="allocationCreateWindow.visible"
      ref="allocationCreateWindow"
      :visible.sync="allocationCreateWindow.visible"
      :list="allocationCreateWindow.list"
      @confirmSync="toQuery"
    />

    <!--    舱位回填-->
    <cabin-space-back-window
      v-if="cabinSpaceBackWindow.visible"
      ref="cabinSpaceBackWindow"
      :visible.sync="cabinSpaceBackWindow.visible"
      :list="cabinSpaceBackWindow.list"
      @confirmSync="toQuery"
    />

    <!-- 退舱 撤销分配-->
    <cancel-cabin-window
      v-if="cancelCabinWindow.visible"
      ref="cancelCabinWindow"
      :visible.sync="cancelCabinWindow.visible"
      :list="cancelCabinWindow.list"
      :type="cancelCabinWindow.type"
      :title="cancelCabinWindow.title"
      @confirmSync="toQuery"
    />
    <el-dialog
      v-if="transshipDialog.visible"
      v-el-drag-dialog
      :visible.sync="transshipDialog.visible"
      :title="$t('SeaExport.BatchVessel')"
      width="850px"
      :close-on-click-modal="false"
    >
      <div style="display: flex">
        <el-form label-width="120px" label-position="left" style="padding-right: 20px">
          <el-form-item :label="$t('SeaExport.Vessel')">
            <div style="display: flex">
              <cargo-advance-select
                :disabled="clearCheckBox.vessel"
                :select-type="selectTypeNames.static_data_Vessel"
                :static-options="transshipDialog.vesselList"
                style="width:195px;"
                :cache="false"
                filterable
                :allow-create="true"
                class="date-blue"
                :default-value="transshipDialog.vessel"
                @parentCallBack="onVesselSelectionChange"
              />
              <el-checkbox v-model="clearCheckBox.vessel" style="margin-left: 10px" @change="clearCheckBoxChange('vessel')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.BookingShipCallSign')">
            <div style="display: flex">
              <el-input v-model="transshipDialog.bookingShipCallSign" :disabled="clearCheckBox.bookingShipCallSign" />
              <el-checkbox v-model="clearCheckBox.bookingShipCallSign" style="margin-left: 10px" @change="clearCheckBoxChange('bookingShipCallSign')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_PortOfLoading')">
            <cargo-advance-select
              style="width:195px;"
              filterable
              :select-type="selectTypeNames.basic_data_Seaport"
              :default-value="transshipDialog.loadingPortCode"
              @parentCallBack="p=>{transshipDialog.loadingPortCode = p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ShippingCompany')">
            <div style="display: flex">
              <cargo-advance-select
                :disabled="clearCheckBox.carrierId"
                filterable
                style="width:195px;"
                options-width="200px;"
                :method-params="{seaCmp:true,active:true}"
                :select-type="selectTypeNames.basic_data_Company"
                :default-value="transshipDialog.txtCarrierId||''"
                @parentCallBack="onCarrierIdSelectionChange"
              />
              <el-checkbox v-model="clearCheckBox.carrierId" style="margin-left: 10px" @change="clearCheckBoxChange('carrierId')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DateOfDeparture2')">
            <el-date-picker
              v-model="transshipDialog.dfETD"
              type="date"
              value-format="yyyy-MM-dd"
              style="width:195px;"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DateOfArrival2')">
            <div style="display: flex">
              <el-date-picker
                v-model="transshipDialog.dfETA"
                :disabled="clearCheckBox.eta"
                type="date"
                value-format="yyyy-MM-dd"
                style="width:195px;"
              />
              <el-checkbox v-model="clearCheckBox.eta" style="margin-left: 10px" @change="clearCheckBoxChange('eta')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_AirlineCode')">
            <el-input v-model="transshipDialog.routeCode" style="width:195px;" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DeclareCutOffDate')">
            <div style="display: flex">
              <el-date-picker
                v-model="transshipDialog.declareCutOff"
                :disabled="clearCheckBox.declareCutOff"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
              <el-checkbox v-model="clearCheckBox.declareCutOff" style="margin-left: 10px" @change="clearCheckBoxChange('declareCutOff')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_CarrierCode')">
            <div style="display: flex">
              <el-input v-model="transshipDialog.carrierCode" :disabled="clearCheckBox.carrierCode" />
              <el-checkbox v-model="clearCheckBox.carrierCode" style="margin-left: 10px" @change="clearCheckBoxChange('carrierCode')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CustomerClosingTime')">
            <div style="display: flex">
              <el-date-picker
                v-model="transshipDialog.customerFileCutoff"
                :disabled="clearCheckBox.customerFileCutoff"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
              <el-checkbox v-model="clearCheckBox.customerFileCutoff" style="margin-left: 10px" @change="clearCheckBoxChange('customerFileCutoff')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
        </el-form>
        <el-form label-width="120px" label-position="left">
          <el-form-item :label="$t('SeaExport.Voyage')">
            <div style="display: flex">
              <cargo-advance-select
                ref="voyageSelect"
                :disabled="clearCheckBox.voyage"
                style="width:195px;"
                :static-options="transshipDialog.voyages || []"
                :cache="false"
                :default-value="transshipDialog.voyage"
                filterable
                clearable
                :allow-create="true"
                tag-name="voyageNo"
                tag-value="voyageNo"
                :filter-tag-names="['voyageNo']"
                @parentCallBack="onVoyageFlightChange"
              />
              <el-checkbox v-model="clearCheckBox.voyage" style="margin-left: 10px" @change="clearCheckBoxChange('voyage')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.HarborDistrict')">
            <div style="display: flex">
              <el-input v-model="transshipDialog.portDistrict" :disabled="clearCheckBox.portDistrict" />
              <el-checkbox v-model="clearCheckBox.portDistrict" style="margin-left: 10px" @change="clearCheckBoxChange('portDistrict')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="'IMO'">
            <div style="display: flex">
              <el-input v-model="transshipDialog.imo" :disabled="clearCheckBox.imo" />
              <el-checkbox v-model="clearCheckBox.imo" style="margin-left: 10px" @change="clearCheckBoxChange('imo')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_PortOfDischarge')">
            <cargo-advance-select
              style="width:195px;"
              filterable
              :select-type="selectTypeNames.basic_data_Seaport"
              :default-value="transshipDialog.dischargingPortCode"
              @parentCallBack="p=>{dischargingPortCodeChange(p);transshipDialog.dischargingPortCode = p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PlaceOfDelivery')">
            <div style="display: flex">
              <cargo-advance-select
                style="width:195px;"
                filterable
                :select-type="selectTypeNames.basic_data_Seaport"
                :default-value="transshipDialog.deliveryPlace"
                @parentCallBack="p=>{transshipDialog.deliveryPlace = p.value}"
              />
              <el-checkbox v-model="clearCheckBox.deliveryPlace" style="margin-left: 10px" @change="clearCheckBoxChange('deliveryPlace')">{{ $t('CargoMsg.Cargo_ClearData') }}
              </el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.BookingAgent')">
            <div style="display: flex">
              <cargo-advance-select
                :disabled="clearCheckBox.bookingAgent"
                filterable
                style="width:195px;"
                options-width="200px;"
                :method-params="{bookingAgent:true,active:true}"
                :select-type="selectTypeNames.basic_data_Company"
                :default-value="transshipDialog.txtBookingAgent||''"
                @parentCallBack="p=>transshipDialog.txtBookingAgent=p.cmpIdx"
              />
              <el-checkbox v-model="clearCheckBox.bookingAgent" style="margin-left: 10px" @change="clearCheckBoxChange('bookingAgent')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item class="warn-label" :label="$t('SeaExport.PortAreaCYCutOffTime')">
            <div style="display: flex">
              <el-date-picker
                v-model="transshipDialog.terminalCutoff"
                :disabled="clearCheckBox.terminalCutoff"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
              <el-checkbox v-model="clearCheckBox.terminalCutoff" style="margin-left: 10px" @change="clearCheckBoxChange('terminalCutoff')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DocCutOffDate')">
            <div style="display: flex">
              <el-date-picker
                v-model="transshipDialog.fileCutoff"
                :disabled="clearCheckBox.fileCutoff"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
              <el-checkbox v-model="clearCheckBox.fileCutoff" style="margin-left: 10px" @change="clearCheckBoxChange('fileCutoff')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CYCutOffDate2')">
            <div style="display: flex">
              <el-date-picker
                v-model="transshipDialog.customCutoff"
                :disabled="clearCheckBox.customCutoff"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
              <el-checkbox v-model="clearCheckBox.customCutoff" style="margin-left: 10px" @change="clearCheckBoxChange('customCutoff')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" style="margin-left: 20px;width: fit-content;">
        <span>{{ $t('Message.UpdateVoyageInfoMessage') }}</span>
        <div style="display: flex; flex-wrap: wrap; gap: 20px; margin-top: 10px;">
          <div>
            <el-checkbox v-model="job.op">{{ $t('CargoMsg.Cargo_Operation') }}</el-checkbox>
            <el-checkbox v-model="job.csr">{{ $t('CargoMsg.Cargo_CustomerService') }}</el-checkbox>
            <el-checkbox v-model="job.dc">{{ $t('CargoMsg.Cargo_Documents') }}</el-checkbox>
            <el-checkbox v-model="job.sales">{{ $t('CargoMsg.Cargo_Sales') }}</el-checkbox>
          </div>
          <div>
            <el-checkbox v-model="job.userDefinedRoleId1">{{ $t('CargoMsg.Cargo_userDefinedRole1') }}</el-checkbox>
            <el-checkbox v-model="job.userDefinedRoleId2">{{ $t('CargoMsg.Cargo_userDefinedRole2') }}</el-checkbox>
            <el-checkbox v-model="job.planer">{{ $t('CargoMsg.Cargo_AirlinePerson') }}</el-checkbox>
          </div>
        </div>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="transShipClickHandler">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="transshipDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import URL from '@/api/urlTranslator'
import {
  advancedQueryFunc,
  batchDeleteCabinManagement,
  batchUpdateCabin,
  copySaveByJobFunc
} from '@/api/booking/cabinManagement'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CopyWindow from '@/views/cargo/v0/SeaExport/cabinManagement/copyWindow.vue'
import CustomsReturnRecovery from '@/views/cargo/v0/SeaExport/cabinManagement/customsReturnRecovery.vue'
import CabinSpaceBackWindow from '@/views/cargo/v0/SeaExport/cabinManagement/cabinSpaceBackWindow.vue'
import { ALLOCATION_0, ALLOCATION_1, CABIN_2, CABIN_3, STATE_COMMITED, STATE_VERIFIED, STATE_COMMITTING, STATE_PRE_COMMIT } from '@/class/cargo/model/parameters/SystemConstants'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import CancelCabinWindow from '@/views/cargo/v0/SeaExport/cabinManagement/cancelCabinWindow.vue'
import AllocationCreate from '@/views/cargo/v0/SeaExport/cabinManagement/allocationCreate.vue'
import { doJumpFinaceOrBusiness } from '@/components/Cargo/grid/routerAndPrintHelp'
import { BC_CARGO_TYPE, LCL_CARGO_TYPE } from '@/class/cargo/model/parameters/ContainerLoadType'
import moment from 'moment'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import DateUtils from '@/utils/dateUtils'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { loadSpecificBasicInfo } from '@/api/cache'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect.vue'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import { batchTransship, getVoyagesByVesselId } from '@/api/seaExport/seaExportJob'
import { Vessel } from '@/class/model/mdm/Vessel'
import lang from '@/lang'
import { getJobByKeys, getSeaExportByKeys } from '@/api/booking/job'
import ErrorTip from '@/utils/class/ErrorTip'
import { querySubscribeConfig } from '@/api/sysManage/subscribePortPushRule'
import { cache } from '@/utils/cacheManager'
import { OPERATOR_BATCH } from '@/class/cargo/model/utils/AdvancedSearchConsts'

export default {
  name: 'CabinList',
  components: {
    CargoAdvanceSelect, cargoCompanySelect,
    AllocationCreate,
    CancelCabinWindow,
    CabinSpaceBackWindow,
    CopyWindow,
    CustomsReturnRecovery,
    searchItem
  },
  props: {
    context: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      URL,
      selectTypeNames: TYPE_NAMES,
      exportOrderCommand: this.$t('SeaExport.Add'),
      isAdvancedQuery: false, // 是否为高级查询
      pageCount: 0,
      SystemConstants: SystemConstants,
      listType: 0,
      filter: {
        conditions: [],
        total: 0,
        pageNum: 1,
        pageSize: 50
      },
      headers: {
        sessionId: this.$store.getters.token,
        ContentType: 'multipart/form-data'
      },
      customsReturnRecoveryWindow: {
        visible: false,
        sourceType: 0,
        cabinData: null,
        title: ''
      },
      allocationCreateWindow: {
        visible: false,
        list: []
      },
      cabinSpaceBackWindow: {
        visible: false,
        list: []
      },
      businessDate: [
        new Date(moment().format('YYYY-MM-DD')),
        null
      ],
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      cancelCabinWindow: {
        visible: false,
        list: [],
        type: 0,
        title: ''
      },
      transshipDialog: {
        visible: false,
        // isVoyages: false,
        jobKeys: [],
        cabinKeys: [],
        selectedJobs: [],
        isDBFlag: true,
        dischargingPortCode: '', // 卸货港代码
        loadingPortCode: '', // 起运港代码
        vessel: '',
        // txtVessel_1: '',
        bookingShipCallSign: '',
        voyage: '',
        txtVoyage_1: '',
        deliveryPlace: '',
        txtCarrierId: '',
        dfETD: '',
        dfETA: '',
        imo: '',
        txtBookingAgent: '',
        portDistrict: '',
        fileCutoff: '',
        terminalCutoff: '',
        customCutoff: '',
        declareCutOff: '', // 截申报日期
        customerFileCutoff: '', // 客户截单时间
        voyages: '',
        transship: {},
        routeCode: '',
        carrierCode: '',
        cleanPolPortInfo: false,
        vesselList: []
      },
      clearCheckBox: {
        deliveryPlace: false,
        vessel: false,
        bookingShipCallSign: false,
        voyage: false,
        carrierId: false,
        // etd: false,
        eta: false,
        imo: false,
        bookingAgent: false,
        portDistrict: false,
        fileCutoff: false,
        terminalCutoff: false, // 港区截港时间
        customCutoff: false, // 截关日期
        declareCutOff: false, // 截申报日期
        customerFileCutoff: false, // 客户截单时间
        // voyages: false,
        // routeCode: false,
        carrierCode: false
      },
      job: {
        op: true,
        csr: false,
        dc: false,
        sales: false,
        userDefinedRoleId1: false,
        userDefinedRoleId2: false,
        planer: false
      },
      templateName: null,
      filterJson: {},
      selectData: null,
      fullscreenLoading: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        // 选中
        onRowClicked: (event) => {
          this.selectData = event.data
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          if (this.gridOptions.api && event.column) {
            this.gridOptions.api.forEachNode(node => {
              if (node.rowIndex === event.rowIndex) {
                this.selectData = node.data
              }
            })
          }
        },
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.selectedRows = this.gridOptions.api.getSelectedRows()
        }
      },
      gridParams: {},
      gridApi: null,
      treeGridParams: {},
      treeGridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        treeData: true,
        groupDefaultExpanded: 3,
        getDataPath: data => {
          return data.path.split(',')
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        autoGroupColumnDef: {
          headerName: this.$t('CargoMsg.Cargo_VoyageInformation'),
          field: '',
          tooltipValueGetter: (params) => {
            return ''
          },
          width: 240,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: params => {
              const dataType = params.data.dataType
              return dataType === 3
            },
            innerRenderer: params => {
              const data = params.data
              if (data.dataType === 1) {
                return params.value// 树状图层级 etd
              } else if (data.dataType === 2) {
                return data.showTreeName// 船名航次
              } else if (data.dataType === 3) {
                return '' // 实际舱位
              } else {
                return ''
              }
            }
          }
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectData = null
          if (nodes[event.rowIndex]) {
            this.selectData = nodes[event.rowIndex].data || null
          }
        },
        // 多选（勾选框触发）
        onRowSelected: event => {
          if (event.data.dataType === 3) { // 有效选中
            this.selectedRows = this.treeGridApi.getSelectedRows().filter(p => p.dataType === 3)
          } else {
            event.node.setSelected(false) // 取消无效选中
          }
          this.changeTypeNameFunc()
        },
        onSortChanged: event => {
          // 重置单选行
          if (this.selectData) {
            const rowIndex = this.selectData.rowIndex
            this.selectData = null
            event.api.setFocusedCell(rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        context: {
          componentParent: this
        }
      },
      treeGridApi: null,
      treeColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_CabinSpaceSerialNo'),
          colId: 'allocationSerialNumber',
          field: 'allocationSerialNumber',
          width: 150
        }, {
          headerName: 'MBL NO.',
          colId: 'mblNo',
          field: 'mblNo',
          width: 150
        }, {
          headerName: 'SO NO.',
          colId: 'soNo',
          field: 'soNo',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_ChineseFirstVesselName'),
          colId: 'shipName',
          field: 'shipName',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_VoyageNo'),
          colId: 'voyage',
          field: 'voyage',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CarrierShip'),
          colId: 'carrierId',
          field: 'carrierId',
          width: 200,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_5')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_BookingAgent'),
          colId: 'bookingAgent',
          field: 'bookingAgent',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_SailingDate') + 'ETD',
          colId: 'etd',
          field: 'etd',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ArrivalDate') + 'ETA',
          colId: 'eta',
          field: 'eta',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ContainerDescription'),
          colId: 'boxTypeQuantity',
          field: 'boxTypeQuantity',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_dispatchingPlace'),
          colId: 'loadingPort',
          field: 'loadingPort',
          width: 150,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_POL'),
          colId: 'departurePort',
          field: 'departurePort',
          width: 150,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_PortOfDischarge'),
          colId: 'dischargePort',
          field: 'dischargePort',
          width: 150,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_PlaceOfDelivery'),
          colId: 'deliveryPlace',
          field: 'deliveryPlace',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Airline'),
          colId: 'regionName',
          field: 'regionName',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_AirlineCode'),
          colId: 'routeCode',
          field: 'routeCode',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CabinSpaceStatus'),
          colId: 'cabinSpaceStatus',
          field: 'cabinSpaceStatus',
          width: 150,
          cellRenderer: (params) => {
            if (params.data.jobFlag) {
              return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.SHIPPING_MANAGERS)
            } else {
              if (params.data.dataType === 3) {
                return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.CABIN_LIST)
              }
            }
            return ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_AllocationStatus'),
          colId: 'allocationStatus',
          field: 'allocationStatus',
          width: 150,
          cellRenderer: (params) => {
            if (params.data.dataType === 3) {
              return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.ALLOCATION_LIST)
            } else {
              return ''
            }
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ShippingCompanyContractNo'),
          colId: 'scNo',
          field: 'scNo',
          width: 150
        }, {
          headerName: 'IMO',
          colId: 'imo',
          field: 'imo',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_VesselCallSign'),
          colId: 'shipCallSign',
          field: 'shipCallSign',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CarrierCode'),
          colId: 'shipEdiCode',
          field: 'shipEdiCode',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Creator'),
          colId: 'createdBy',
          field: 'createdBy',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CreatedDate'),
          colId: 'dateCreated',
          field: 'dateCreated',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_AirlinePerson'),
          colId: 'routeManager',
          field: 'routeManager',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperationOffice'),
          colId: 'branchId',
          field: 'branchId',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CabinSpaceNote'),
          colId: 'allocationNote',
          field: 'allocationNote',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_GuidedSellingPrice'),
          colId: 'guideSellingPrice',
          field: 'guideSellingPrice',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CutOffDate'),
          colId: 'cutOffDate',
          field: 'cutOffDate',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_DeclarationCutOffDate'),
          colId: 'declarationDate',
          field: 'declarationDate',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CYCutOffDate'),
          colId: 'sealingDate',
          field: 'sealingDate',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CutOffDate2'),
          colId: 'customerSealDate',
          field: 'customerSealDate',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ReturnDateForCustoms'),
          colId: 'customerWithdrawalDate',
          field: 'customerWithdrawalDate',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CutOffTime'),
          colId: 'customerCutOffTime',
          field: 'customerCutOffTime',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_FreeDetension'),
          colId: 'freeChestRentPeriod',
          field: 'freeChestRentPeriod',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_FreeStorageDays'),
          colId: 'freeStackDays',
          field: 'freeStackDays',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_market'),
          colId: 'sales',
          field: 'sales',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_AuthorizedClient'),
          colId: 'customerId',
          field: 'customerId',
          width: 150,
          cellRenderer: (params) => {
            if (params.data.masterFlag && [LCL_CARGO_TYPE.code, BC_CARGO_TYPE.code].includes(params.data.containerLoadType)) {
              return ''
            }
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_0') : ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CabinSpaceAllocationDate'),
          colId: 'allocationDate',
          field: 'allocationDate',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_AssociatedBusinessNo'), field: 'jobNo',
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'multi-router-and-print',
            attrs: params => {
              return {
                useRoute: true,
                usePrint: false,
                jumpMethod: value => {
                  doJumpFinaceOrBusiness(this, value, 'SE', params.data.branchId, true)
                }
              }
            }
          },
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AssociatedBusinessStatus'),
          colId: 'jobStatus',
          field: 'jobStatus',
          width: 150,
          cellRenderer: (params) => {
            if (params.data.jobNo) {
              return ColumnUtils.getJobStateCN(params.value)
            } else {
              return ''
            }
          }
        }, {
          headerName: 'TEU',
          colId: 'teu',
          field: 'teu',
          width: 100,
          cellRenderer: (params) => {
            if (params.data.dataType === 3) {
              return params.value
            } else {
              return ''
            }
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CabinCancellationExplanation'),
          colId: 'withdrawalExplanation',
          field: 'withdrawalExplanation',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_CabinSpaceRecord'),
          colId: 'allocationRemark',
          field: 'allocationRemark',
          width: 200
        }],
      columnDefs: [
        {
          headerName: '',
          width: 55,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CabinSpaceSerialNo'),
          colId: 'allocationSerialNumber',
          field: 'allocationSerialNumber',
          width: 150
        }, {
          headerName: 'MBL NO.',
          colId: 'mblNo',
          field: 'mblNo',
          width: 150
        }, {
          headerName: 'SO NO.',
          colId: 'soNo',
          field: 'soNo',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_ChineseFirstVesselName'),
          colId: 'shipName',
          field: 'shipName',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_VoyageNo'),
          colId: 'voyage',
          field: 'voyage',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CarrierShip'),
          colId: 'carrierId',
          field: 'carrierId',
          width: 200,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_5')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_BookingAgent'),
          colId: 'bookingAgent',
          field: 'bookingAgent',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_SailingDate') + 'ETD',
          colId: 'etd',
          field: 'etd',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ArrivalDate') + 'ETA',
          colId: 'eta',
          field: 'eta',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ContainerDescription'),
          colId: 'boxTypeQuantity',
          field: 'boxTypeQuantity',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_dispatchingPlace'),
          colId: 'loadingPort',
          field: 'loadingPort',
          width: 150,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_POL'),
          colId: 'departurePort',
          field: 'departurePort',
          width: 150,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_PortOfDischarge'),
          colId: 'dischargePort',
          field: 'dischargePort',
          width: 150,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_PlaceOfDelivery'),
          colId: 'deliveryPlace',
          field: 'deliveryPlace',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Airline'),
          colId: 'regionName',
          field: 'regionName',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_AirlineCode'),
          colId: 'routeCode',
          field: 'routeCode',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CabinSpaceStatus'),
          colId: 'cabinSpaceStatus',
          field: 'cabinSpaceStatus',
          width: 150,
          cellRenderer: (params) => {
            if (params.data.jobFlag) {
              return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.SHIPPING_MANAGERS)
            } else {
              if (params.data.dataType === 3) {
                return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.CABIN_LIST)
              }
            }
            return ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_AllocationStatus'),
          colId: 'allocationStatus',
          field: 'allocationStatus',
          width: 150,
          cellRenderer: (params) => {
            if (params.data.dataType === 3) {
              return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.ALLOCATION_LIST)
            } else {
              return ''
            }
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ShippingCompanyContractNo'),
          colId: 'scNo',
          field: 'scNo',
          width: 150
        }, {
          headerName: 'IMO',
          colId: 'imo',
          field: 'imo',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_VesselCallSign'),
          colId: 'shipCallSign',
          field: 'shipCallSign',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CarrierCode'),
          colId: 'shipEdiCode',
          field: 'shipEdiCode',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Creator'),
          colId: 'createdBy',
          field: 'createdBy',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CreatedDate'),
          colId: 'dateCreated',
          field: 'dateCreated',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_AirlinePerson'),
          colId: 'routeManager',
          field: 'routeManager',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperationOffice'),
          colId: 'branchId',
          field: 'branchId',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CabinSpaceNote'),
          colId: 'allocationNote',
          field: 'allocationNote',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_GuidedSellingPrice'),
          colId: 'guideSellingPrice',
          field: 'guideSellingPrice',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CutOffDate'),
          colId: 'cutOffDate',
          field: 'cutOffDate',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_DeclarationCutOffDate'),
          colId: 'declarationDate',
          field: 'declarationDate',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CYCutOffDate'),
          colId: 'sealingDate',
          field: 'sealingDate',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CutOffDate2'),
          colId: 'customerSealDate',
          field: 'customerSealDate',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ReturnDateForCustoms'),
          colId: 'customerWithdrawalDate',
          field: 'customerWithdrawalDate',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CutOffTime'),
          colId: 'customerCutOffTime',
          field: 'customerCutOffTime',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_FreeDetension'),
          colId: 'freeChestRentPeriod',
          field: 'freeChestRentPeriod',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_FreeStorageDays'),
          colId: 'freeStackDays',
          field: 'freeStackDays',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_market'),
          colId: 'sales',
          field: 'sales',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_AuthorizedClient'),
          colId: 'customerId',
          field: 'customerId',
          width: 150,
          cellRenderer: (params) => {
            if (params.data.masterFlag && [LCL_CARGO_TYPE.code, BC_CARGO_TYPE.code].includes(params.data.containerLoadType)) {
              return ''
            }
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_0') : ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CabinSpaceAllocationDate'),
          colId: 'allocationDate',
          field: 'allocationDate',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_AssociatedBusinessNo'), field: 'jobNo',
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'multi-router-and-print',
            attrs: params => {
              return {
                useRoute: true,
                usePrint: false,
                jumpMethod: value => {
                  doJumpFinaceOrBusiness(this, value, 'SE', params.data.branchId, true)
                }
              }
            }
          },
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AssociatedBusinessStatus'),
          colId: 'jobStatus',
          field: 'jobStatus',
          width: 150,
          cellRenderer: (params) => {
            if (params.data.jobNo) {
              return ColumnUtils.getJobStateCN(params.value)
            } else {
              return ''
            }
          }
        }, {
          headerName: 'TEU',
          colId: 'teu',
          field: 'teu',
          width: 100,
          cellRenderer: (params) => {
            if (params.data.dataType === 3) {
              return params.value
            } else {
              return ''
            }
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CabinCancellationExplanation'),
          colId: 'withdrawalExplanation',
          field: 'withdrawalExplanation',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_CabinSpaceRecord'),
          colId: 'allocationRemark',
          field: 'allocationRemark',
          width: 200
        }, {
          headerName: this.$t('SeaExport.CargoType'),
          field: 'cargoType',
          colId: 'cargoType',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', params.value, 'chineseName')
          }
        }],
      rowData: [],
      selectedRows: [],
      showSeaExportJob: false
    }
  },
  computed: {
    selectRowDataLabel() {
      const list = this.selectedRows
      if (list.length > 0) {
        const list0 = list.filter(t => t.allocationStatus === ALLOCATION_0.code)
        const list1 = list.filter(t => t.allocationStatus === ALLOCATION_1.code)
        // 未分配
        const allContainerMap = this.queryContainerData(list0)
        // 已分配
        const selectContainerMap = this.queryContainerData(list1)
        const createLabel = (map) => {
          return Object.keys(map).reduce((acc, key) => {
            const value = map[key]
            acc += `(${value}*${key}) `
            return acc
          }, '')
        }
        let label = ''
        // 勾选的数量
        const selectList = Object.keys(selectContainerMap)
        if (selectList.length > 0) {
          const selectKeyValue = Object.values(selectContainerMap).reduce((acc, value) => acc + Number(value), 0)
          const selectLabel = createLabel(selectContainerMap)
          label = `${this.$t('CargoMsg.Cargo_Allocated')}${selectKeyValue}${selectLabel}`
        }
        // 剩余的数量
        const allList = Object.keys(allContainerMap)
        if (allList.length > 0) {
          const allKeyValue = Object.values(allContainerMap).reduce((acc, value) => acc + Number(value), 0)
          const allLabel = createLabel(allContainerMap)
          label += `${this.$t('CargoMsg.Cargo_NotAllocated')}${allKeyValue}${allLabel}`
        }
        return label
      }
      return ''
    }
  },
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.toQuery()
    }
  },
  methods: {
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 设置ETD过滤
    setETDFilter(filter) {
      if (!filter.conditions) {
        filter.conditions = []
      }
      AdvancedSearchOption.removeOption('cm.ETD', filter.conditions)
      const start = DateUtils.formatStandardDate(this.businessDate[0])
      const end = DateUtils.formatStandardDate(this.businessDate[1])
      if (start && end) {
        filter.conditions.push(new AdvancedSearchOption('FIELD_DATE_RANGE', 'cm.ETD', `type=date,start=${start} 00:00:00,end=${end} 23:59:59`, AdvancedSearchConsts.OPERATOR_RANGE.code))
      } else if (start) {
        filter.conditions.push(new AdvancedSearchOption('FIELD_DATE_RANGE', 'cm.ETD', `type=date,start=${start} 00:00:00`, AdvancedSearchConsts.OPERATOR_RANGE.code))
      } else if (end) {
        filter.conditions.push(new AdvancedSearchOption('FIELD_DATE_RANGE', 'cm.ETD', `type=date,end=${end} 23:59:59`, AdvancedSearchConsts.OPERATOR_RANGE.code))
      }
    },
    // 查询
    toSimpleQuery(keyword) {
      if (typeof keyword !== 'undefined') {
        this.filter.conditions = []
        const option = new AdvancedSearchOption(null, 'cm.ALLOCATION_SERIAL_NUMBER', keyword.trim(), OperatorConstants.OPERATOR_LIKE.code)
        this.filter.conditions.push(option.formatObj2Json())
        this.filter.pageNum = 1
      }
      this.setETDFilter(this.filter)
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.filter.type = this.listType
      this.filter.showSeaExportJob = false
      this.fullscreenLoading = getLoading4Cxt()
      advancedQueryFunc(this.filter).then((res) => this.handleQueryData(res)).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    toDiractQuery(jobNos) {
      this.filter.conditions = [
        new AdvancedSearchOption(null, 'cm.JOB_NO', jobNos, OPERATOR_BATCH.code).formatObj2Json()
      ]
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.filter.type = this.listType
      this.filter.showSeaExportJob = false
      const loading = getLoading4Cxt(this)
      advancedQueryFunc(this.filter).then(res => this.handleQueryData(res)).finally(() => {
        loading.close()
      })
    },
    handleQueryData(res) {
      this.rowData = res.data.list
      for (const data of this.rowData) {
        data.showTreeName = data.uuid
      }
      this.changeTypeNameFunc()
      this.pageCount = res.data.pages
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.filter.total = Number(res.data.total)
      this.fullscreenLoading.close()
    },
    // 批量操作
    batchHandle(val) {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectData'))
        return
      }
      if (!this.jobFlag(this.selectedRows)) return
      switch (val) {
        case 1:
          for (const data of this.selectedRows) {
            if (data.allocationStatus === ALLOCATION_1.code || data.cabinSpaceStatus === CABIN_3.code) {
              this.$message.warning(this.$t('CargoMsg.Cargo_CheckDTip2'))
              return
            }
          }
          this.cabinSpaceBackWindow.list = this.selectedRows
          this.cabinSpaceBackWindow.visible = true
          break
        case 2:
          // 撤销分配
          for (const data of this.selectedRows) {
            if (!data.jobUuid) {
              this.$message.warning(this.$t('CargoMsg.Cargo_CancelCabinTip6'))
              return
            }
          }
          this.cancelCabinWindow.list = this.selectedRows
          this.cancelCabinWindow.title = this.$t('CargoMsg.Cargo_RevokeAllocation')
          this.cancelCabinWindow.type = 0
          this.cancelCabinWindow.visible = true
          break
        case 3:
          // 退舱
          for (const data of this.selectedRows) {
            if (data.jobUuid) {
              this.$message.warning(this.$t('CargoMsg.Cargo_CancelCabinTip3'))
              return
            }
          }
          this.cancelCabinWindow.list = this.selectedRows
          this.cancelCabinWindow.title = this.$t('CargoMsg.Cargo_CancelCabinReservation')
          this.cancelCabinWindow.type = 1
          this.cancelCabinWindow.visible = true
          break
        case 4:
          this.toBatchTransship()
          break
      }
    },
    allocationHandle(val) {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectData'))
        return
      }
      if (!this.jobFlag(this.selectedRows)) return
      for (const data of this.selectedRows) {
        if (data.cabinSpaceStatus !== CABIN_2.code) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AllocateCheck2'))
          return
        }
        if (data.allocationStatus !== ALLOCATION_0.code) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AllocateCheck1'))
          return
        }
      }
      switch (val) {
        case 1:
          if (!this.$checkPermission(['button_cabinManagement_AllocateSEBooking']) && !this.$checkPermission(['button_cabinManagement_AllocateVerify'])) {
            this.$message.warning(this.$t('Sop.hasPermission'))
            return
          }
          if (this.selectedRows && this.selectedRows.length > 1) {
            this.$message.warning(this.$t('Clearing.PleaseCheckARecord'))
            return
          }
          this.customsReturnRecoveryWindow.cabinData = this.selectedRows[0]
          this.customsReturnRecoveryWindow.sourceType = 1
          this.customsReturnRecoveryWindow.title = this.$t('CargoMsg.Cargo_Allocate1')
          this.customsReturnRecoveryWindow.visible = true
          break
        case 2:
          if (!this.$checkPermission(['button_cabinManagement_AllocateCreateSEBooking']) && !this.$checkPermission(['button_cabinManagement_AllocateCreateVerify'])) {
            this.$message.warning(this.$t('Sop.hasPermission'))
            return
          }
          this.allocationCreateWindow.list = this.selectedRows
          this.allocationCreateWindow.visible = true
          break
      }
    },
    // 导出导入订单模板
    exportOrderHandle() {
      switch (this.exportOrderCommand) {
        case this.$t('CargoMsg.Cargo_NewTo'):
          if (!this.$checkPermission(['button_cabinManagement_add'])) {
            this.$message.warning(this.$t('Sop.hasPermission'))
            return
          }
          this.$emit('add')
          break
        case this.$t('CargoMsg.Cargo_SORecognitionNewAdd'):
          break
        case this.$t('CargoMsg.Cargo_DownImportTemplate'):
          ExportUtils.downloadTemplateFile('SlotTemplate.xls', 'booking')
          break
      }
    },
    handleShutOut() {
      this.customsReturnRecoveryWindow.sourceType = 0
      this.customsReturnRecoveryWindow.title = this.$t('CargoMsg.Cargo_CustomsReturnAndRecovery')
      this.customsReturnRecoveryWindow.visible = true
    },
    deleteCabinHandler() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectData'))
        return
      }
      if (!this.jobFlag(this.selectedRows)) return
      for (const data of this.selectedRows) {
        if (data.cabinSpaceStatus !== CABIN_3.code) {
          this.$message.warning(this.$t('CargoMsg.Cargo_OnlyReturnTheCabin'))
          return
        }
      }
      const uuids = Array.from(this.selectedRows, p => p.uuid)
      this.$confirm(this.$t('Message.SureDeleteThese') + uuids.length + this.$t('Message.OrdersOfBusiness'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        this.loading = getLoading4Cxt(this)
        batchDeleteCabinManagement(uuids).then(res => {
          if (res.data) {
            this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
            this.toQuery()
          }
        }).finally(() => {
          this.loading.close()
        })
      }).catch(() => {
      })
    },
    beforeOrderUpload(file) {
      this.fullscreenLoading = getLoading()
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.fullscreenLoading.close()
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
        return
      }
      return extension || extension2
    },
    // 上传成功
    uploadOrderSuccess(res, file, fileList) {
      console.log('uploadOrderSuccess', res)
      this.fullscreenLoading.close()
      if (res.ok) {
        const h = this.$createElement
        this.$msgbox({
          title: this.$t('common.tips.prompt'),
          message: h('p', null, [
            h('p', { style: 'fontSize: 20px;paddingBottom:5px' }, this.$t('CargoMsg.Cargo_ImportingData')),
            h('p', { style: 'color: red' }, this.$t('CargoMsg.Cargo_ImportingDataSuccess'))
          ]),
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'success'
        })
      } else {
        this.$confirm(res.message, this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          canCloseModule: true,
          type: 'warning'
        })
      }
    },
    handleError(error) {
      const errorData = JSON.parse(error.message)
      this.$message.error({ 'message': errorData.message, 'duration': 15000 })
      this.fullscreenLoading.close()
    },
    toAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        this.filter.conditions = data
        this.filter.pageNum = 1
      }
      this.selectedRows = []
      this.filterJson.conditions = this.filter.conditions
      this.setETDFilter(this.filterJson)
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.filterJson.type = this.listType
      this.filterJson.showSeaExportJob = this.showSeaExportJob
      // if (this.showSeaExportJob) {
      //   const jobStates = [SystemConstants.STATE_OPERATING.code, SystemConstants.STATE_COMMITED.code, SystemConstants.STATE_VERIFIED.code, SystemConstants.STATE_PRE_COMMIT.code, SystemConstants.STATE_COMMITTING.code]
      //   const condition1 = new AdvancedSearchOption(null, 'job.JOB_STATE', jobStates, AdvancedSearchConsts.OPERATOR_IN.code)
      //   this.filter.conditions.push(condition1.formatObj2Json())
      //   const condition2 = new AdvancedSearchOption(null, 'job.LOB', SystemConstants.SE.code, AdvancedSearchConsts.OPERATOR_EQUAL.code)
      //   this.filter.conditions.push(condition2.formatObj2Json())
      // }
      this.fullscreenLoading = getLoading4Cxt()
      advancedQueryFunc(this.filterJson).then((res) =>
        this.handleQueryData(res)
      ).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    onRowDoubleClicked() {
      if (this.selectData && this.selectData.dataType !== 2) {
        if (!this.jobFlag([this.selectData])) return
        this.$emit('look', this.selectData)
      }
    },
    toLook() {
      if (this.selectData && this.selectData.dataType !== 2) {
        if (!this.jobFlag([this.selectData])) return
        this.$emit('look', this.selectData)
      }
    },
    toEdit() {
      if (this.selectData && this.selectData.dataType !== 2) {
        if (!this.jobFlag([this.selectData])) return
        this.$emit('edit', this.selectData)
      }
    },
    toClone() {
      if (this.selectData && this.selectData.dataType !== 2) {
        if (!this.jobFlag([this.selectData])) return
        this.$emit('clone', this.selectData)
      }
    },
    changeTypeNameFunc() {
      const list = this.selectedRows
      const dataMap = {}
      const allDataMap = {}
      const allBoxMap = {}
      const selectBoxMap = {}

      // 处理数据类型为3的数据
      for (const data of this.rowData) {
        if (data.dataType !== 3) continue
        const key = data.path.replace('_' + data.uuid, '')
        this.processData(data, key, dataMap, allDataMap, selectBoxMap, allBoxMap, list)
      }

      // 处理数据类型为2的数据
      for (const data of this.rowData) {
        if (data.dataType !== 2) continue
        const selectData = dataMap[data.path] || []
        const allData = allDataMap[data.path] || []
        const allBoxData = allBoxMap[data.path] || {}
        const selectBoxData = selectBoxMap[data.path] || {}

        let boxLabel = ''
        Object.keys(allBoxData).forEach(key => {
          if (boxLabel) boxLabel += ';'
          const selectDataCount = selectBoxData[key] || 0
          boxLabel += `${key}:[${selectDataCount}/${allBoxData[key]}]`
        })

        // 组装第二节点label
        data.showTreeName = `${data.uuid} (${this.$t('SeaExport.Bl')}:[${selectData.length}/${allData.length}];${boxLabel})`
      }

      this.treeGridOptions.api.refreshCells({ force: true })
    },
    processData(data, key, dataMap, allDataMap, selectBoxMap, allBoxMap, list) {
      const mapList = dataMap[key] || []
      const allMapList = allDataMap[key] || []
      const selectMap = selectBoxMap[key] || {}
      const boxMap = allBoxMap[key] || {}

      this.boxData(data, boxMap)
      if (list && list.length > 0) {
        for (const item of list) {
          if (data.path === item.path) {
            this.boxData(item, selectMap)
            mapList.push(item)
          }
        }
      }
      selectBoxMap[key] = selectMap
      allBoxMap[key] = boxMap
      allMapList.push(data)
      dataMap[key] = mapList
      allDataMap[key] = allMapList
    },
    queryContainerData(list) {
      const map = {}
      for (const data of list) {
        if (data.dataType !== 3) {
          continue
        }
        this.boxData(data, map)
      }
      return map
    },
    boxData(data, map) {
      if (data.boxTypeQuantity) {
        const boxList = data.boxTypeQuantity.split('\n')
        for (const box of boxList) {
          const boxValue = box.split('*')
          const boxQ = map[boxValue[1]] || 0
          map[boxValue[1]] = Number(boxValue[0]) + Number(boxQ)
        }
      }
    },
    confirmSyncHandler(event) {
      if (!event) {
        return
      }
      this.fullscreenLoading = getLoading4Cxt()
      const item = {}
      item.uuids = event.uuids
      item.cancelBookingRemark = event.note
      item.branchId = this.$store.getters.currentOfficeId
      copySaveByJobFunc(item).then(res => {
        JobUtils.createSuccessHandler(this, res, event.back)
        this.toQuery()
      }).catch((err) => {
        throw err
      }).finally(() => {
        if (this.fullscreenLoading) {
          this.fullscreenLoading.close()
        }
      })
    },
    // 设置不可选日期范围
    disabledDate(currDate) {
      const beforeTwoYear = moment().subtract(2, 'y').subtract(1, 'days')
      return currDate < beforeTwoYear
    },
    jobFlag(datas) {
      const data = datas.find(p => p.jobFlag)
      if (data) {
        this.$message.warning(this.$t('CargoMsg.Cargo_OperatingSpaceOnly'))
        return false
      }
      return true
    },
    // 批量转船
    async toBatchTransship() {
      const rows = this.readSelectedRows()
      if (rows.length <= 0) {
        this.$message.info(this.$t('Message.SelectTheData'))
        return
      }
      this.toInitClearCheckBox()
      this.toInitTransshipDialog()
      const shipName = (rows[0].shipName ? rows[0].shipName.trim() : rows[0].shipName)
      const voyage = (rows[0].voyage ? rows[0].voyage.trim() : rows[0].voyage)
      for (const item of rows) {
        // 如果船名航次不一致 给出提示
        const curshipName = (item.shipName ? item.shipName.trim() : item.shipName)
        const curvoyage = (item.voyage ? item.voyage.trim() : item.voyage)
        if (curshipName !== shipName || curvoyage !== voyage) {
          this.$message.info(this.$t('Message.TheSelectedDocumentIsNotTheSameVoyage'))
          return
        }
        this.transshipDialog.cabinKeys.push(item.uuid)
        if (item.jobUuid) {
          this.transshipDialog.jobKeys.push(item.jobUuid)
        }
        this.transshipDialog.selectedJobs.push(item)
      }
      // 船名 船次赋值
      this.transshipDialog.vessel = shipName
      this.transshipDialog.voyage = voyage
      // 校验选中的这些数据起运港、卸货港、交货地、船公司、航线代码、ETD、ETA 是否一致 一致的话就去弹框页面展示出来
      const allLoadingPortCodeSame = rows.every(row => row.departurePort === rows[0].departurePort)
      const allDischargingPortCodeSame = rows.every(row => row.dischargePort === rows[0].dischargePort)
      const allDeliveryPlaceSame = rows.every(row => row.deliveryPlace === rows[0].deliveryPlace)
      const allCarrierIdSame = rows.every(row => row.carrierId === rows[0].carrierId)
      const allRouteCodeSame = rows.every(row => row.routeCode === rows[0].routeCode)
      const allEtdSame = rows.every(row => row.etd === rows[0].etd)
      const allEtaSame = rows.every(row => row.eta === rows[0].eta)
      if (allLoadingPortCodeSame) {
        this.transshipDialog.loadingPortCode = rows[0].departurePort
      }
      if (allDischargingPortCodeSame) {
        this.transshipDialog.dischargingPortCode = rows[0].dischargePort
      }
      if (allDeliveryPlaceSame) {
        this.transshipDialog.deliveryPlace = rows[0].deliveryPlace
      }
      if (allCarrierIdSame) {
        this.transshipDialog.txtCarrierId = rows[0].carrierId
      }
      if (allRouteCodeSame) {
        this.transshipDialog.routeCode = rows[0].routeCode
      }
      if (allEtdSame) {
        this.transshipDialog.dfETD = rows[0].etd
      }
      if (allEtaSame) {
        this.transshipDialog.dfETA = rows[0].eta
      }
      this.transshipDialog.visible = true
      this.transshipDialog.vesselList = await loadSpecificBasicInfo('Vessel').then(res => res.data)
    },
    toInitClearCheckBox() {
      this.clearCheckBox.vessel = false
      this.clearCheckBox.voyage = false
      this.clearCheckBox.carrierId = false
      this.clearCheckBox.eta = false
      this.clearCheckBox.portDistrict = false
      this.clearCheckBox.fileCutoff = false
      this.clearCheckBox.terminalCutoff = false
      this.clearCheckBox.customCutoff = false
      this.clearCheckBox.bookingAgent = false
      this.clearCheckBox.bookingShipCallSign = false
      this.clearCheckBox.imo = false
      this.clearCheckBox.carrierCode = false
      this.clearCheckBox.deliveryPlace = false
      this.clearCheckBox.declareCutOff = false
      this.clearCheckBox.customerFileCutoff = false
      this.job.op = true
      this.job.csr = false
      this.job.dc = false
      this.job.sales = false
      this.job.userDefinedRoleId1 = false
      this.job.userDefinedRoleId2 = false
      this.job.planer = false
    },
    clearCheckBoxChange(key = '') {
      switch (key) {
        case 'vessel':
          if (this.clearCheckBox.vessel) {
            this.transshipDialog.vessel = ''
          }
          break
        case 'bookingShipCallSign':
          if (this.clearCheckBox.bookingShipCallSign) {
            this.transshipDialog.bookingShipCallSign = ''
          }
          break
        case 'carrierId':
          if (this.clearCheckBox.carrierId) {
            this.transshipDialog.txtCarrierId = 0
          }
          break
        case 'eta':
          if (this.clearCheckBox.eta) {
            this.transshipDialog.dfETA = ''
          }
          break
        case 'imo':
          if (this.clearCheckBox.imo) {
            this.transshipDialog.imo = ''
          }
          break
        case 'bookingAgent':
          if (this.clearCheckBox.bookingAgent) {
            this.transshipDialog.txtBookingAgent = 0
          }
          break
        case 'portDistrict':
          if (this.clearCheckBox.portDistrict) {
            this.transshipDialog.portDistrict = ''
          }
          break
        case 'fileCutoff':
          if (this.clearCheckBox.fileCutoff) {
            this.transshipDialog.fileCutoff = ''
          }
          break
        case 'terminalCutoff':
          if (this.clearCheckBox.terminalCutoff) {
            this.transshipDialog.terminalCutoff = ''
          }
          break
        case 'customCutoff':
          if (this.clearCheckBox.customCutoff) {
            this.transshipDialog.customCutoff = ''
          }
          break
        case 'declareCutOff':
          if (this.clearCheckBox.declareCutOff) {
            this.transshipDialog.declareCutOff = ''
          }
          break
        case 'customerFileCutoff':
          if (this.clearCheckBox.customerFileCutoff) {
            this.transshipDialog.customerFileCutoff = ''
          }
          break
        case 'voyage':
          if (this.clearCheckBox.voyage) {
            this.transshipDialog.voyage = ''
          }
          break
        case 'carrierCode':
          if (this.clearCheckBox.carrierCode) {
            this.transshipDialog.carrierCode = ''
          }
          break
        case 'deliveryPlace':
          if (this.clearCheckBox.deliveryPlace) {
            this.transshipDialog.deliveryPlace = ''
          }
          break
        default:
      }
    },
    toInitTransshipDialog() {
      this.transshipDialog.selectedJobs = []
      this.transshipDialog.dischargingPortCode = ''
      this.transshipDialog.loadingPortCode = ''
      this.transshipDialog.isDBFlag = true
      this.transshipDialog.vessel = ''
      this.transshipDialog.voyage = ''
      this.transshipDialog.txtVoyage_1 = ''
      this.transshipDialog.txtCarrierId = ''
      this.transshipDialog.dfETD = ''
      this.transshipDialog.dfETA = ''
      this.transshipDialog.portDistrict = ''
      this.transshipDialog.fileCutoff = ''
      this.transshipDialog.terminalCutoff = ''
      this.transshipDialog.customCutoff = ''
      this.transshipDialog.txtBookingAgent = ''
      this.transshipDialog.jobKeys = []
      this.transshipDialog.cabinKeys = []
      this.transshipDialog.transship = {}
      this.transshipDialog.bookingShipCallSign = ''
      this.transshipDialog.imo = ''
      this.transshipDialog.routeCode = ''
      this.transshipDialog.carrierCode = ''
      this.transshipDialog.vesselAndVoyage = ''
      this.transshipDialog.deliveryPlace = ''
    },
    // 批量转船点击确定
    async transShipClickHandler() {
      const transShipLoading = getLoading4Cxt()
      const selectComponent = this.$refs.voyageSelect
      const inputValue = selectComponent.$el.querySelector('input').value
      const currentValue = selectComponent.getCurrentValue
        ? selectComponent.getCurrentValue()
        : selectComponent.selectedValue
      this.transshipDialog.voyage = currentValue || inputValue
      try {
        let jobs = null
        let seaJobs = null
        if (this.transshipDialog.jobKeys && this.transshipDialog.jobKeys.length > 0) {
          jobs = await getJobByKeys(this.transshipDialog.jobKeys).then(res => res.data)
          if (jobs && jobs.length > 0) {
            const validStateObjects = [
              STATE_COMMITED.code,
              STATE_VERIFIED.code,
              STATE_PRE_COMMIT.code,
              STATE_COMMITTING.code
            ]
            for (const seaJob of jobs) {
              if (validStateObjects.includes(seaJob.jobState)) {
                this.$message.warning(this.$t('Message.BusinessOperationsCannotBeModified'))
                return
              }
            }
          }
        }
        const obj = {}
        obj.jobKeys = this.transshipDialog.jobKeys
        obj.cabinKeys = this.transshipDialog.cabinKeys
        let cleanVesselAndVoyage = false
        let changeVesselAndVoyage = false
        if (this.transshipDialog.vessel) {
          obj.vessel = this.transshipDialog.vessel
          obj.shipName = obj.vessel // 船名
          changeVesselAndVoyage = true
        } else {
          if (this.clearCheckBox.vessel) {
            obj.vessel = ''
            obj.shipName = obj.vessel // 船名
            cleanVesselAndVoyage = true
          }
        }
        if (this.transshipDialog.bookingShipCallSign) {
          obj.bookingShipCallSign = this.transshipDialog.bookingShipCallSign
          obj.shipCallSign = obj.bookingShipCallSign // 舱位船舶呼号
          obj.vesselCode = obj.bookingShipCallSign
        } else {
          if (this.clearCheckBox.bookingShipCallSign) {
            obj.bookingShipCallSign = ''
            obj.shipCallSign = obj.bookingShipCallSign // 舱位船舶呼号
            obj.vesselCode = obj.bookingShipCallSign
          }
        }
        if (this.transshipDialog.imo) { // imo编号
          obj.imo = this.transshipDialog.imo
        } else {
          if (this.clearCheckBox.imo) {
            obj.imo = ''
          }
        }
        if (this.transshipDialog.voyage) {
          obj.voyage = this.transshipDialog.voyage // 船次
          changeVesselAndVoyage = true
        } else {
          if (this.clearCheckBox.voyage) { // 船次
            obj.voyage = ''
            cleanVesselAndVoyage = true
          }
        }
        const carrierId = this.transshipDialog.txtCarrierId
        if (carrierId && carrierId > 0) {
          obj.carrierId = carrierId
        } else {
          if (this.clearCheckBox.carrierId) {
            obj.carrierId = 0
          }
        }
        if (this.transshipDialog.dfETD) {
          obj.etd = this.transshipDialog.dfETD
        }
        if (this.transshipDialog.dfETA) {
          obj.eta = this.transshipDialog.dfETA
        } else {
          if (this.clearCheckBox.eta) {
            obj.eta = null
          }
        }
        if (this.transshipDialog.portDistrict) {
          obj.portDistrict = this.transshipDialog.portDistrict
        } else {
          if (this.clearCheckBox.portDistrict) {
            obj.portDistrict = ''
          }
        }
        if (this.transshipDialog.fileCutoff) {
          obj.fileCutoff = this.transshipDialog.fileCutoff
          obj.cutOffDate = this.transshipDialog.fileCutoff
        } else {
          if (this.clearCheckBox.fileCutoff) {
            obj.fileCutoff = null
            obj.cutOffDate = null
          }
        }
        if (this.transshipDialog.terminalCutoff) {
          obj.terminalCutoff = this.transshipDialog.terminalCutoff
        } else {
          if (this.clearCheckBox.terminalCutoff) {
            obj.terminalCutoff = null
          }
        }
        if (this.transshipDialog.customCutoff) {
          obj.customCutoff = this.transshipDialog.customCutoff
          obj.sealingDate = this.transshipDialog.customCutoff
        } else {
          if (this.clearCheckBox.customCutoff) {
            obj.customCutoff = null
            obj.sealingDate = null
          }
        }
        const bookingAgent = this.transshipDialog.txtBookingAgent
        if (bookingAgent && bookingAgent > 0) {
          obj.bookingAgent = bookingAgent
        } else {
          if (this.clearCheckBox.bookingAgent) {
            obj.bookingAgent = 0
          }
        }
        if (this.transshipDialog.dischargingPortCode) {
          obj.dischargingPortCode = this.transshipDialog.dischargingPortCode
          obj.dischargingPort = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', obj.dischargingPortCode, 'englishName')
          obj.dischargePort = obj.dischargingPortCode
        }

        if (this.transshipDialog.loadingPortCode) {
          obj.loadingPortCode = this.transshipDialog.loadingPortCode
          obj.loadingPort = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', obj.loadingPortCode, 'englishName')
          obj.departurePort = obj.loadingPortCode
        }
        // 交货地
        if (this.transshipDialog.deliveryPlace) {
          obj.deliveryPlaceCode = this.transshipDialog.deliveryPlace
          // obj.deliveryPlace = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', obj.deliveryPlaceCode, 'englishName')
        }
        if (this.transshipDialog.routeCode) {
          obj.routeCode = this.transshipDialog.routeCode
        } else {
          if (this.clearCheckBox.routeCode) {
            obj.routeCode = ''
          }
        }
        if (this.transshipDialog.carrierCode) {
          obj.carrierCode = this.transshipDialog.carrierCode
          obj.shipEdiCode = this.transshipDialog.carrierCode
        } else {
          if (this.clearCheckBox.carrierCode) {
            obj.carrierCode = ''
            obj.shipEdiCode = ''
          }
        }
        obj.syncPod = Number(cache.config.get('SyncPOD')) === 1
        obj.currentOfficeId = this.$store.getters.currentOfficeId
        if (this.transshipDialog.declareCutOff) {
          obj.declareCutOff = this.transshipDialog.declareCutOff
          obj.declarationDate = this.transshipDialog.declareCutOff
        } else {
          if (this.clearCheckBox.declareCutOff) {
            obj.declareCutOff = null
            obj.declarationDate = null
          }
        }
        if (this.transshipDialog.customerFileCutoff) {
          obj.customerFileCutoff = this.transshipDialog.customerFileCutoff
          obj.customerCutOffTime = this.transshipDialog.customerFileCutoff
        } else {
          if (this.clearCheckBox.customerFileCutoff) {
            obj.customerFileCutoff = null
            obj.customerCutOffTime = null
          }
        }
        if (jobs && jobs.length > 0) {
          seaJobs = await getSeaExportByKeys(this.transshipDialog.jobKeys).then(res => res.data)
          obj.updateCabin = true // 在跟新业务的同时 是否更新舱位
          // 校验勾选了那些角色
          // 勾选了那些角色
          if (this.job.op) {
            obj.op = true
          }
          if (this.job.csr) {
            obj.csr = true
          }
          if (this.job.dc) {
            obj.dc = true
          }
          if (this.job.sales) {
            obj.sales = true
          }
          if (this.job.userDefinedRoleId1) {
            obj.userDefinedRoleId1 = true
          }
          if (this.job.userDefinedRoleId2) {
            obj.userDefinedRoleId2 = true
          }
          if (this.job.planer) {
            obj.planer = true
          }
          // 校验数据有没有变化，如果都没有变化就不需要发邮件
          const hasDifferentValuesJob = jobs.some(job => {
            return (
              (obj.hasOwnProperty('vessel') && job.vessel !== obj.vessel) ||
              (obj.hasOwnProperty('bookingShipCallSign') && job.bookingShipCallSign !== obj.bookingShipCallSign) ||
              (obj.hasOwnProperty('imo') && job.imo !== obj.imo) ||
              (obj.hasOwnProperty('carrierId') && job.carrierId !== obj.carrierId) ||
              (obj.hasOwnProperty('etd') && job.etd !== obj.etd) ||
              (obj.hasOwnProperty('eta') && job.eta !== obj.eta) ||
              (obj.hasOwnProperty('bookingAgent') && job.bookingAgent !== obj.bookingAgent) ||
              (obj.hasOwnProperty('dischargingPortCode') && job.dischargingPortCode !== obj.dischargingPortCode) ||
              (obj.hasOwnProperty('loadingPortCode') && job.loadingPortCode !== obj.loadingPortCode) ||
              (obj.hasOwnProperty('deliveryPlaceCode') && job.destinationPortCode !== obj.deliveryPlaceCode)
            )
          })
          const hasDifferentValuesSeaJob = seaJobs.some(seaJob => {
            return (
              (obj.hasOwnProperty('portDistrict') && seaJob.portDistrict !== obj.portDistrict) ||
              (obj.hasOwnProperty('fileCutoff') && seaJob.fileCutoff !== obj.fileCutoff) ||
              (obj.hasOwnProperty('terminalCutoff') && seaJob.terminalCutoff !== obj.terminalCutoff) ||
              (obj.hasOwnProperty('customCutoff') && seaJob.customCutoff !== obj.customCutoff) ||
              (obj.hasOwnProperty('routeCode') && seaJob.routeCode !== obj.routeCode) ||
              (obj.hasOwnProperty('carrierCode') && seaJob.carrierCode !== obj.carrierCode) ||
              (obj.hasOwnProperty('declareCutOff') && seaJob.declareCutOff !== obj.declareCutOff)
            )
          })
          console.log('yewu-->', jobs[0].bookingAgent)
          console.log('obj-->', obj.bookingAgent)
          console.log('hasDifferentValuesSeaJob-->', hasDifferentValuesJob + '--' + hasDifferentValuesSeaJob)
          // 如果没有勾选这些角色 则不发送邮件
          if (hasDifferentValuesJob || hasDifferentValuesSeaJob) {
            if (this.job.op || this.job.csr || this.job.dc || this.job.sales || this.job.userDefinedRoleId1 || this.job.userDefinedRoleId2 || this.job.planer) {
              obj.sendEmail = true
            }
          }
          // 弹框提示 要更新业务信息
          this.$confirm(this.$t('Message.updateBatchTips'), this.$t('Message.Confirm'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning'
          }).then(() => {
            const fieldMsg = []
            for (const job of jobs) {
              if (fieldMsg.length === 7) {
                break
              }
              if (job.portDistrict && !fieldMsg.includes(lang.t('SeaExport.HarborDistrict'))) {
                fieldMsg.push(lang.t('SeaExport.HarborDistrict'))
              }
              if (job.berthPlanDate && !fieldMsg.includes(lang.t('SeaExport.PlannedBerthingTime'))) {
                fieldMsg.push(lang.t('SeaExport.PlannedBerthingTime'))
              }
              if (job.unBerthPlanDate && !fieldMsg.includes(lang.t('SeaExport.PlanDepartureTime'))) {
                fieldMsg.push(lang.t('SeaExport.PlanDepartureTime'))
              }
              if (job.actualBerthPlanDate && !fieldMsg.includes(lang.t('SeaExport.ActualBerthingTime'))) {
                fieldMsg.push(lang.t('SeaExport.ActualBerthingTime'))
              }
              if (job.actualUnBerthPlanDate && !fieldMsg.includes(lang.t('SeaExport.RealDepartureTime'))) {
                fieldMsg.push(lang.t('SeaExport.RealDepartureTime'))
              }
              if (job.terminalOpendate && !fieldMsg.includes(lang.t('SeaExport.CYOpeningTime'))) {
                fieldMsg.push(lang.t('SeaExport.CYOpeningTime'))
              }
              if (job.terminalCutoff && !fieldMsg.includes(lang.t('SeaExport.PortAreaCYCutOffTime'))) {
                fieldMsg.push(lang.t('SeaExport.PortAreaCYCutOffTime'))
              }
            }
            if (cleanVesselAndVoyage || changeVesselAndVoyage) {
              // 清空设置 清空修改船名航次清空船期数据
              let subscribeConfig = null
              this.transshipDialog.cleanPolPortInfo = false
              querySubscribeConfig({}).then(res => {
                if (res.data && res.data.length > 0) {
                  subscribeConfig = res.data[0]
                }
              })
              if (subscribeConfig && subscribeConfig.cleanPolPortInfo) {
                this.transshipDialog.cleanPolPortInfo = true
              }
              const curVoyageFlight = (jobs[0].voyageFlight ? jobs[0].voyageFlight.trim() : jobs[0].voyageFlight)
              const curVessel = (jobs[0].vessel ? jobs[0].vessel.trim() : jobs[0].vessel)
              let flagInfo = false
              if (((this.transshipDialog.vessel && this.transshipDialog.vessel !== curVessel) ||
                (this.transshipDialog.voyage && this.transshipDialog.voyage !== curVoyageFlight)) || cleanVesselAndVoyage) {
                flagInfo = true
              }
              if (!this.transshipDialog.cleanPolPortInfo && flagInfo && fieldMsg.length > 0) {
                this.$confirm(lang.t('CargoMsg.Cargo_UpdateVesselVoyageMsg', [fieldMsg.join(',')]), lang.t('common.tips.prompt'), {
                  confirmButtonText: lang.t('SeaExport.Yes'),
                  cancelButtonText: lang.t('SeaExport.No'),
                  closeOnClickModal: false,
                  type: 'info'
                }).then(() => {
                  obj.cleanPolPortInfo = true
                  this.transshipDialog.transship = obj
                  const loading = getLoading4Cxt()
                  batchTransship(obj).then().finally(() => {
                    loading.close()
                  })
                  for (const job of jobs) {
                    job.portDistrict = ''
                    job.berthPlanDate = ''
                    job.unBerthPlanDate = ''
                    job.actualBerthPlanDate = ''
                    job.actualUnBerthPlanDate = ''
                    job.terminalOpendate = ''
                    job.terminalCutoff = ''
                  }
                }).catch(async() => {
                  await this.executeBatchTransship(obj)
                })
              } else {
                this.executeBatchTransship(obj, this.transshipDialog.cleanPolPortInfo)
                if (this.transshipDialog.cleanPolPortInfo) {
                  for (const job of jobs) {
                    job.portDistrict = ''
                    job.berthPlanDate = ''
                    job.unBerthPlanDate = ''
                    job.actualBerthPlanDate = ''
                    job.actualUnBerthPlanDate = ''
                    job.terminalOpendate = ''
                    job.terminalCutoff = ''
                  }
                }
              }
            } else {
              this.executeBatchTransship(obj)
            }
          }).catch(() => {
          })
        } else {
          // job为空 只需要更新船舱信息
          const loading = getLoading4Cxt(this)
          this.transshipDialog.transship = obj
          batchUpdateCabin(obj).then(res => {
            this.batchTransshipFresh()
            this.$message.success(this.$t('Message.batchUpdateShipSuccess'))
            this.transshipDialog.visible = false
          }).catch((err) => {
            throw err
          }).finally(() => {
            if (loading) {
              loading.close()
            }
          })
        }
      } finally {
        transShipLoading.close()
      }
    },
    // 批量转船 刷新
    batchTransshipFresh() {
      const objCabinKey = {}
      const cabinKeys = this.transshipDialog.cabinKeys
      for (const cabinKey of cabinKeys) {
        objCabinKey[cabinKey] = cabinKey
      }

      const transship = this.transshipDialog.transship
      for (const cabin of this.rowData) {
        if (objCabinKey.hasOwnProperty(cabin.uuid) && objCabinKey[cabin.uuid] === cabin.uuid) {
          if (transship.hasOwnProperty('vessel')) {
            cabin.shipName = transship.vessel
          }
          if (transship.hasOwnProperty('shipCallSign')) {
            cabin.shipCallSign = transship.shipCallSign
          }
          if (transship.hasOwnProperty('carrierId')) {
            cabin.imo = transship.imo
          }
          if (transship.hasOwnProperty('voyage')) {
            cabin.voyage = transship.voyage
          }
          if (transship.hasOwnProperty('carrierId')) {
            cabin.carrierId = transship.carrierId
          }
          if (transship.hasOwnProperty('etd')) {
            cabin.etd = transship.etd
          }
          if (transship.hasOwnProperty('eta')) {
            cabin.eta = transship.eta
          }
          if (transship.hasOwnProperty('cutOffDate')) {
            cabin.cutOffDate = transship.cutOffDate
          }
          if (transship.hasOwnProperty('sealingDate')) {
            cabin.sealingDate = transship.sealingDate
          }
          if (transship.hasOwnProperty('bookingAgent')) {
            cabin.bookingAgent = transship.bookingAgent
          }
          if (transship.hasOwnProperty('dischargePort')) {
            cabin.dischargePort = transship.dischargePort
          }
          if (transship.hasOwnProperty('departurePort')) {
            cabin.departurePort = transship.departurePort
          }
          if (transship.hasOwnProperty('deliveryPlaceCode')) {
            cabin.deliveryPlace = transship.deliveryPlaceCode
          }
          if (transship.hasOwnProperty('routeCode')) {
            cabin.routeCode = transship.routeCode
          }
          if (transship.hasOwnProperty('shipEdiCode')) {
            cabin.shipEdiCode = transship.shipEdiCode
          }
          if (transship.hasOwnProperty('declarationDate')) {
            cabin.declarationDate = transship.declarationDate
          }
          if (transship.hasOwnProperty('customerCutOffTime')) {
            cabin.customerCutOffTime = transship.customerCutOffTime
          }
        }
      }
      this.refreshAgGrid()
    },
    // 刷新表格
    refreshAgGrid() {
      this.gridApi.refreshCells({ force: true })
      this.gridApi.redrawRows()
    },
    // 根据船名查询航次
    async onVesselSelectionChange(obj) {
      this.transshipDialog.vessel = obj.value
      this.transshipDialog.voyage = ''
      this.transshipDialog.bookingShipCallSign = ''
      this.transshipDialog.carrierCode = ''
      this.currentVessel = obj
      if (obj.value && obj.vesselId) {
        await getVoyagesByVesselId(obj.vesselId).then(res => {
          this.transshipDialog.voyages = res.data
        })
      } else {
        this.transshipDialog.voyages = []
      }
      if (obj.value && obj.uuid) {
        this.transshipDialog.imo = obj.imoCode
        await this.getVesselCarrier()
      } else {
        this.transshipDialog.imo = ''
      }
    },
    async getVesselCarrier() {
      if (this.currentVessel && this.currentVessel.uuid) {
        const vessel = new Vessel(this.currentVessel)
        const vesselCarriers = await vessel.getVesselCarriers()
        for (const carrier of vesselCarriers) {
          if (carrier.carrierId === this.transshipDialog.txtCarrierId) {
            this.transshipDialog.bookingShipCallSign = carrier.edicode
            this.transshipDialog.carrierCode = carrier.edicode
          }
        }
      }
    },
    async onCarrierIdSelectionChange(data) {
      this.transshipDialog.txtCarrierId = data.cmpIdx
      await this.getVesselCarrier()
    },
    readSelectedRows(tips = true) {
      const allRows = this.gridApi.getModel().rowsToDisplay.filter(node => node.data && node.selected).map(node => node.data)
      const rows = []
      for (const row of allRows) {
        rows.push(row)
      }
      if (rows.length === 0 && tips) {
        throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
      }
      return rows
    },
    //  卸货港代码改变如果配置为1 则同步交货地
    dischargingPortCodeChange(data) {
      const dischargingPortCode = data.value
      if (Number(cache.config.get('SyncPOD')) === 1) {
        this.transshipDialog.deliveryPlace = dischargingPortCode
      }
    },
    async onVoyageFlightChange(data) {
      this.transshipDialog.routeCode = data.routeCode
    },
    async executeBatchTransship(obj, changeVesselAndVoyage = false) {
      const loading = getLoading4Cxt()
      obj.cleanPolPortInfo = changeVesselAndVoyage
      this.transshipDialog.transship = obj
      try {
        await batchTransship(obj).then(res => {
          this.batchTransshipFresh()
          this.$message.success(this.$t('Message.batchUpdateShipSuccess'))
          this.transshipDialog.visible = false
        })
      } finally {
        loading.close()
      }
    }
  }
}
</script>

<style scoped>
.custom-checkbox {
  .el-form-item__content {
    .el-checkbox {
      .el-checkbox__label {
        font-size: 14px !important;
        color: #555 !important;
      }
    }
  }
}
</style>
